import { useMemo } from 'react'
import { useQueries } from 'react-query'

import locationAPI, { LocationNameDataResponse } from '@api/location'
import locationUtils from '@lib/location'
import { useParams } from '@stores/params'

const useLocationNames = (codes: string[] = []) => {
  const [{ locale }] = useParams()

  const queries = useQueries(
    codes.map(code => {
      const params = { route: { code }, query: { type: locationUtils.getLocationType(code), locale } }

      return {
        queryKey: ['locations', params],
        queryFn: () => locationAPI.getLocationNameData(params),
        enabled: !!code,
        cacheTime: 10 * 60 * 1000,
        staleTime: 10 * 60 * 1000,
      }
    }),
  )

  const isLoading = useMemo(() => queries.some(({ isLoading }) => isLoading), [queries])
  const data = useMemo(() => queries.map(({ data }) => data).filter(Boolean) as LocationNameDataResponse[], [queries])

  return {
    isLoading,
    data,
  }
}

export default useLocationNames
